import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();

    let anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');
    if (anchorLinks.length) {
        Array.prototype.forEach.call(anchorLinks, (entry, i) => {
            if (entry.pathname.replace(/^\//, '') == window.location.pathname.replace(/^\//, '') && entry.hostname == window.location.hostname) {
                entry.setAttribute('data-scroll-to', '');
                entry.setAttribute('data-scroll-to-offset', '-160');
            }
            entry.addEventListener('click', (e) => {
                try {
                    let href = entry.getAttribute('href');
                    setTimeout(() => {
                        document.querySelector(href).closest('.c-accordion__section').classList.add('is-open');
                    }, 500);
                } catch (e) { }

            });
        });
    }

    let hashAtLoad = window.location.hash;
    if (hashAtLoad) {
        try {
            let target = document.querySelector(hashAtLoad);
            if (target) {
                setTimeout(() => {
                    target.closest('.c-accordion__section').classList.add('is-open');
                }, 500);
            }
        } catch (e) { }
    }

    let links = document.querySelectorAll('a[href^="mailto"]');
    for (let j = 0; j < links.length; j++) {
        links[j].setAttribute('target', '_blank');
    }

    // Trackings
    // Track all mailto click
    let mailtoLinks = document.querySelectorAll('a[href^="mailto"]');
    mailtoLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_email',
                'page_category': window.pageCategory
            });
        });
    });

    // Track all links to /actualites/
    let blogLinks = document.querySelectorAll('a[href*="/actualites"]');
    blogLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_vers_blog',
                'page_category': window.pageCategory
            });
        });
    });
    let blogLinksEn = document.querySelectorAll('a[href*="/en/news"]');
    blogLinksEn.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_vers_blog',
                'page_category': window.pageCategory
            });
        });
    });

    // Track all links to omnivox.ca
    let omnivoxLinks = document.querySelectorAll('a[href*="omnivox.ca"]');
    omnivoxLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_omnivox',
                'page_category': window.pageCategory
            });
        });
    });
    
    // Track links to calculateur
    let calculateurLinks = document.querySelectorAll('a[href*="calculateur"]');
    calculateurLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_frais_admission',
                'page_category': window.pageCategory
            });
        });
    });

    // Track links to jedonneenligne
    let jedonneenligneLinks = document.querySelectorAll('a[href*="jedonneenligne"]');
    jedonneenligneLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_vers_don',
                'page_category': window.pageCategory
            });
        });
    });

    // Click navigation
    let navigationLinks = document.querySelectorAll('.js-nav-overlay a');
    navigationLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_menu_principal',
                'page_category': window.pageCategory
            });
        });
    });

    // Click on elements with class o-contact-box__link
    let contactBoxLinks = document.querySelectorAll('.o-contact-box__link');
    contactBoxLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'click_sticky',
                'page_category': window.pageCategory
            });
        });
    });

    window.fixLinksTarget = function () {
        // Add target blank to all external links
        let externalLinks = document.querySelectorAll('a');
        const isExternalURL = (u) => { try { return new URL(u).origin !== location.origin; } catch(e) { return false; } };
        externalLinks.forEach((link) => {
            if (!isExternalURL(link.href)) {
                link.setAttribute('target', '_self');
                link.setAttribute('rel','');
                return; 
            }

            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
            var ariaLabel = "Ouvre dans une nouvelle fenêtre";
            if (location.href.match(/\/en\//)) 
                ariaLabel = "Opens in a new window";
            if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', ariaLabel);
        });
        
        // Add target blank to all pdf and docx links
        let fileLinks = document.querySelectorAll('a[href*=".pdf"], a[href*=".docx"]');
        fileLinks.forEach((link) => {
            link.setAttribute('target', '_blank');
            var ariaLabel = "Ouvre dans une nouvelle fenêtre";
            if (location.href.match(/\/en\//)) 
                ariaLabel = "Opens in a new window";
            link.setAttribute('aria-label', ariaLabel);
        });

        //Remove target blank on links starting with https://www.etsmtl.ca/etudes/cour/* or https://www.etsmtl.ca/en/study/courses/*
        let courseLinks = document.querySelectorAll('a[href^="https://www.etsmtl.ca/etudes/cours/"], a[href^="https://www.etsmtl.ca/en/study/courses/"], a[href^="/etudes/cours/"], a[href^="/en/study/courses/"]');
        courseLinks.forEach((link) => {
            link.removeAttribute('target');
            link.removeAttribute('rel');
        });


        // If window.isProgram add click on (".o-boxed-info__text a") to track click on program
        if (window.isProgram) {
            let programLinks = document.querySelectorAll('.o-boxed-info__text a');
            programLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'click_dates-admission',
                        'page_category': 'Programmes',
                        'departement': programInfos.departement,
                        'cycle': programInfos.cycle,
                        'diplome': programInfos.diplome,
                        'programme_code': programInfos.code,
                        'programme_nom': programInfos.name,
                        'onglet': link.querySelector('.c-nav-anchors__link-text').innerHTML,
                    });
                });
            });
        }
    }
    window.fixLinksTarget();

    // if link to png jpg or eps add target blank
    let imageLinks = document.querySelectorAll('a[href*="uploads"]');
    imageLinks.forEach((link) => {
        link.setAttribute('target', '_blank');
        var ariaLabel = "Ouvre dans une nouvelle fenêtre";
        if (location.href.match(/\/en\//))
            ariaLabel = "Opens in a new window";
        if (!link.getAttribute('aria-label')) {
            link.setAttribute('aria-label', ariaLabel);
        }
    });

    /*if (document.cookie.indexOf('dsc=1') > -1) {
        let element = document.querySelector('#craft-element');
        let pageId = element.dataset.page;
        let sitename = element.dataset.sitename || 'default';
        if (pageId) {
            let str = `
                <div class="c-craft-tools">
                    <div class="c-craft-tools__user">
                        <span class="c-craft-tools__user__name">
                            Bienvenue
                        </span>
                    </div>
                    <a class="c-craft-tools__edit" href="/admin/entries/edit/${pageId}?site=${sitename}" target="_blank">
                        Éditer cette page
                    </a>
                </div>
            `;
            // Insert this at the beginning of the body
            document.body.insertAdjacentHTML('afterbegin', str);
        }
    }*/

    document.querySelectorAll('[data-entry-id="942889"] main a').forEach(e => e.target='_blank')
}
